import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { httpCreateSubcontractor } from '../../../Hooks/company/company.post.hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';

const SubcontractorSubmit = ({ subcontractor, companyId }) => {
  const [status, setStatus] = useState('');

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ companyId, subcontractor }) =>
      httpCreateSubcontractor(companyId, subcontractor),
    onSuccess: async (data) => {
      let message = await data.json();
      queryClient.invalidateQueries(['subcontractors']);
      setStatus(message.msg || 'Subcontractor has been created');
    },
    onError: async (error) => {
      let err = await error.json();
      console.error('Error creating subcontractor:', error);
      setStatus(err.msg || 'Failed to create subcontractor');
    },
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Creating Subcontractor...');
    mutation.mutate({
      companyId,
      subcontractor,
    });
  };
  return (
    <SubmitContainer>
      <TopSubmit>
        {status.length > 0 && <p className="result">{status}</p>}
      </TopSubmit>
      <BottomSubmit>
        <PrimaryButtonComponent
          span="Create Subcontractor"
          functionName={handleSubmit}
        />
      </BottomSubmit>
      <span className="m1T">Email will NOT be sent on submit</span>
    </SubmitContainer>
  );
};
SubcontractorSubmit.propTypes = {
  subcontractor: PropTypes.object,
  companyId: PropTypes.string,
};
export default SubcontractorSubmit;
